import { useState } from "react";
import LayoutActividad from "../../../components/LayoutActividad";
import Imagen1 from "../../../images/modulo10/pizarramonica.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { modulo10 } from "../../../routes/Module10";
import Sidebar from "../Sidebar";
import Card from "../../../components/Card";
import GuiaDocente from "../../../components/GuiaDocente";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo10/Actividad 3.mp3";

const Actividad3 = () => {
  const [answers, setAnswers] = useState({
    ans1: { value: "", valid: "", correctValue: "representan" },
    ans2: { value: "", valid: "", correctValue: "fiscalizan" },
    ans3: { value: "", valid: "", correctValue: "partido político" },
    ans4: { value: "", valid: "", correctValue: "legislan" },
  });
  const infoUnidad = modulo10.content[0];
  const infoAct = modulo10.content[0].activities[2];
  const crumbs = [
    {
      title: modulo10.title,
      url: "/" + modulo10.url,
    },
    {
      title:
        modulo10.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `${modulo10.content[0].activities[3].name}`,
    linkNext: `${modulo10.url}/${modulo10.content[0].path}/${modulo10.content[0].activities[3].path}`,
    titlePrev: `${modulo10.content[0].activities[1].name}`,
    linkPrev: `${modulo10.url}/${modulo10.content[0].path}/${modulo10.content[0].activities[1].path}`,
  };

  const metadata = {
    color: modulo10.color,
    title: `${modulo10.title} - ${infoAct.name}`,
    name: modulo10.title,
  };
  const validateAnswers = (event) => {
    event.preventDefault();
    let newAnswers = answers;
    Object.keys(newAnswers).forEach(
      (key) =>
        (newAnswers[key]["valid"] =
          answers[key]["correctValue"].toUpperCase() ===
          answers[key]["value"].toUpperCase()
            ? "is-valid"
            : "is-invalid")
    );
    setAnswers({ ...newAnswers });
  };
  const handleAnswers = (event, name) => {
    event.preventDefault();
    setAnswers({
      ...answers,
      [name]: { ...answers[name], value: event.target.value },
    });
  };
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo10.color} hat-text`}>
          <FontAwesomeIcon icon={faEdit} /> Trabajamos con las palabras
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />
      <ul>
        <li>Lee lo escrito por la profesora Mónica en la pizarra.</li>
      </ul>
      <div className="row mb-1">
        <div className="col-12 text-center">
          <img src={Imagen1} alt="Pizarra" className="img-fluid" />
        </div>
      </div>
      <ul>
        <li>
          Fíjate en las palabras subrayadas. ¿Qué crees que significan? Completa
          las siguientes oraciones con dichas palabras.
        </li>
      </ul>
      <div className="row">
        <div className="col-lg-8 col-12">
          <Card>
            1. Los y las congresistas son intermediarios entre las personas y
            las instituciones del Estado. Eso quiere decir que{" "}
            <input
              type="text"
              className={
                "form-control form-control-sm d-inline-block w-200 " +
                answers.ans1.valid
              }
              value={answers.ans1.value}
              onChange={(event) => handleAnswers(event, "ans1")}
            />{" "}
            a los ciudadanos.
          </Card>
          <Card>
            2. El Congreso vigila o controla al Poder Ejecutivo y a otras
            instituciones del Estado para asegurarse de que cumplan con su
            trabajo. Eso significa que{" "}
            <input
              type="text"
              className={
                "form-control form-control-sm d-inline-block w-200 " +
                answers.ans2.valid
              }
              value={answers.ans2.value}
              onChange={(event) => handleAnswers(event, "ans2")}
            />{" "}
            lo que hacen los demás.
          </Card>
          <Card>
            3. Un{" "}
            <input
              type="text"
              className={
                "form-control form-control-sm d-inline-block w-200 " +
                answers.ans3.valid
              }
              value={answers.ans3.value}
              onChange={(event) => handleAnswers(event, "ans3")}
            />{" "}
            es un grupo de personas que tienen las mismas ideas sobre cómo
            gobernar un país. Participan de las elecciones.
          </Card>
          <Card>
            4. Los y las congresistas proponen, revisan y aprueban leyes para el
            beneficio de todos los peruanos y peruanas. Eso quiere decir que
            <input
              type="text"
              className={
                "form-control form-control-sm d-inline-block w-200 " +
                answers.ans4.valid
              }
              value={answers.ans4.value}
              onChange={(event) => handleAnswers(event, "ans4")}
            />{" "}
            .
          </Card>
          <div className="d-flex w-100 justify-content-end my-4">
            <button
              className={`btn btn-${modulo10.color}`}
              onClick={validateAnswers}
            >
              Enviar respuestas
            </button>
          </div>
        </div>
      </div>

      <GuiaDocente>
        <p>
          Lea las indicaciones y los textos. Se trata de palabras complejas así
          que debe ayudar a comprenderlas. Puede dar ejemplos de cómo usarlas.
          Las respuestas son las siguientes: representan, fiscalizan, partido
          político y legislan.
        </p>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad3;
